module.exports = __webpack_public_path__ + "img/add-startup-preview.676a974c.png";